export * from './RichTextFooterBlock';

export * from './Model/model';
export * from './RichTextFooterBlock.types';
